var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_5188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.2959C9.07981 17.2959 6.70407 14.9202 6.70407 12C6.70407 9.07981 9.07981 6.70407 12 6.70407C14.9202 6.70407 17.2959 9.07981 17.2959 12C17.2959 14.9202 14.9202 17.2959 12 17.2959ZM12 7.56345C9.55368 7.56345 7.56345 9.55368 7.56345 12C7.56345 14.4463 9.55368 16.4366 12 16.4366C14.4463 16.4366 16.4366 14.4463 16.4366 12C16.4366 9.55368 14.4463 7.56345 12 7.56345Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.0518C10.8687 14.0518 9.94824 13.1313 9.94824 12C9.94824 10.8687 10.8687 9.94824 12 9.94824C13.1313 9.94824 14.0518 10.8687 14.0518 12C14.0518 13.1313 13.1314 14.0518 12 14.0518ZM12 10.8076C11.3425 10.8076 10.8076 11.3425 10.8076 12C10.8076 12.6575 11.3425 13.1924 12 13.1924C12.6575 13.1924 13.1924 12.6575 13.1924 12C13.1924 11.3425 12.6575 10.8076 12 10.8076Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.2959C9.71289 17.2959 7.27543 16.4273 4.9511 14.784C3.20747 13.5512 2.14848 12.3319 2.10422 12.2806C1.96524 12.1193 1.96524 11.8807 2.10422 11.7195C2.14844 11.6682 3.20747 10.4488 4.9511 9.21606C7.27543 7.5727 9.71289 6.70407 12 6.70407C14.2871 6.70407 16.7246 7.5727 19.0489 9.21602C20.7925 10.4488 21.8515 11.6682 21.8958 11.7194C22.0348 11.8807 22.0348 12.1193 21.8958 12.2806C21.8516 12.3318 20.7925 13.5512 19.0489 14.784C16.7246 16.4273 14.2871 17.2959 12 17.2959ZM3.01516 12C3.42204 12.4232 4.28629 13.2638 5.4652 14.0949C6.98032 15.1632 9.34391 16.4366 12 16.4366C14.6562 16.4366 17.0197 15.1632 18.5348 14.0949C19.7138 13.2637 20.5779 12.4232 20.9849 12C20.578 11.5768 19.7138 10.7363 18.5348 9.90509C17.0197 8.83684 14.6561 7.56345 12 7.56345C9.34395 7.56345 6.98032 8.83684 5.4652 9.90509C4.28625 10.7363 3.42207 11.5768 3.01516 12Z",
    fill: "#464646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_5188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.cf5eafb3cde987a63243300d382c8f2a.svg";
export { ForwardRef as ReactComponent };